import React from "react";
import { Modal } from "../../";

const PluginModal = ({ isOpen, onClose, title, url }) => {
  if (!isOpen || !url) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title || "Plugin Settings"}>
      <div className="h-[70vh] w-full">
        <iframe
          src={url}
          className="h-full w-full rounded-lg border-0"
          title={title || "Plugin Settings"}
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
        />
      </div>
    </Modal>
  );
};

export default PluginModal;
